import React from 'react'
import PropTypes from 'prop-types'

import CellarEvent from 'components/CellarEvent'
import GiftCardBox from 'components/GiftCardBox'
import CellarEventsFilters from 'components/CellarEventsFilters'

class CellarEvents extends React.Component {
  filterEvents(eventsFilters) {
    const {
      events,
      eventsCurrentLanguage,
    } = this.props

    let eventList = []
    for (const eventId of Object.keys(events)) {
      const event = events[eventId][eventsCurrentLanguage]
      if (event) {
        eventList.push(event)
      }
    }

    if (eventsFilters.location) {
      eventList = eventList.filter(e => e.location._id === eventsFilters.location)
    }

    if (eventsFilters.tag) {
      eventList = eventList.filter(e =>
        e.tags.find(({ tag }) => tag === eventsFilters.tag)
      )
    }

    if (
      eventsFilters.dates &&
      eventsFilters.dates.from &&
      eventsFilters.dates.to
    ) {
      const { from, to } = eventsFilters.dates
      const fromString = from.toISOString().substring(0, 10)
      const toString = to.toISOString().substring(0, 10)
      eventList = eventList.filter(e =>
        e.dates.find(({ d }) => {
          const dateString = d.substring(0, 10)
          return fromString <= dateString &&
            toString >= dateString
        })
      )
    }

    return eventList
  }

  render() {
    const {
      locale,
      giftCards,
      cellar,
      cellarId,
      eventsFilters,
    } = this.props
    const eventItems = []
    const eventList = this.filterEvents(eventsFilters)

    const orderedEvents = eventList.sort((a, b) => a.order - b.order)
    for (const event of orderedEvents) {
      if (!event.published) {
        continue
      }

      eventItems.push(
        <CellarEvent key={`event-${event._id}`} event={event} locale={locale} />
      )
    }

    if (giftCards && giftCards.length) {
      let i = 0
      for (const giftCard of giftCards) {
        const giftCardComponent = (
          <GiftCardBox
            key={`gift-card-${i++}`}
            giftCard={giftCard}
            locale={locale}
            cellarId={cellarId}
            giftCardId={giftCard._id}
          />
        )
        if (giftCard.position === 'first') {
          eventItems.unshift(giftCardComponent)
        } else {
          eventItems.push(giftCardComponent)
        }
      }
    }

    return (
      <div className="events">
        <div className="wrap">
          <div className="events__container">
            {
              cellar.showEventsFilters
                ? (
                  <CellarEventsFilters
                    eventsFilters={eventsFilters}
                    getEvents={(filters) => this.filterEvents(filters)}
                    currentLanguage={locale}
                  />
                )
                : ''
            }
          </div>
          <div className="events__container">
            { eventItems }
          </div>
        </div>
      </div>
    )
  }
}

CellarEvents.propTypes = {
  cellar: PropTypes.object.isRequired,
  cellarId: PropTypes.string.isRequired,
  events: PropTypes.object.isRequired,
  eventsCurrentLanguage: PropTypes.string.isRequired,
  eventsLanguages: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
  giftCards: PropTypes.array,
  eventsFilters: PropTypes.object,
}

export default CellarEvents
